import * as React from 'react';

import { getUrlHashedValue } from '../storage/storage-utils';
import DisplayModal from '../common/DisplayModal';
import ProductDetailsCard from './ProductDetailsCard';
import ProductCardForGrid from  './ProductCardForGrid'; 
import PropTypes from 'prop-types';

/**
 *  This component displays both both inline/grid product card and the modal product view  
 */
const DispensaryProduct = (
  {
    Id = '-1',  // .id
    name,       // .display_info
    brand,
    description,
    category={},
    image_url,
    cost_usa_cents,
    is_featured,
    grams,
    leaf_logix_pricing_tier,
    thc_lab_value,
    thc_lab_units,
    cbd_lab_value,
    cbd_lab_units,
    cannabis_type,
    dispensaryId,
    handleClick,
    quantity, 
    showOrderQuantity,
    isFullWidth
  }) => {
 
  const [showModal, setShowModal] = React.useState(false);
  
  // Handle this for both views
  const imageInfo = {
    productImage: image_url,
    productCategory: category.display_name 
  };

  // This allows us to trigger a specific product modal via URL hash
  // This might be used on /allProducts admin page
  React.useEffect(() => {
    const hashedProdId = window.location.hash ? getUrlHashedValue('prodId') : '';  
    if (Id === hashedProdId ) {
      setShowModal(true);  
    } 
  } ,[Id, setShowModal]); 

  // Add to cart and auto-close modal
  const addToCartClick = (quantity) => {
    handleClick(quantity); 
    setShowModal(false);
  }; 
  
  return (
    <>
      {/* inline card */}
       <ProductCardForGrid 
          Id={Id} 
          Name={name}
          category={category} 
          imageInfo={imageInfo}
          brand={brand} 
          cost_usa_cents={cost_usa_cents}
          is_featured={is_featured}
          leaf_logix_pricing_tier={leaf_logix_pricing_tier}
          thc_lab_value={thc_lab_value}
          thc_lab_units={thc_lab_units}
          cbd_lab_value={cbd_lab_value}
          cbd_lab_units={cbd_lab_units}
          cannabisType={cannabis_type}
          grams={grams} 
          orderQuantity={quantity}
          dispensaryId={dispensaryId} 
          showOrderQuantity={showOrderQuantity}
          isFullWidth={isFullWidth}
          handleCartClick={(quantity) => addToCartClick(quantity)}
          handleClick={() => setShowModal(true)}
        />
      {/* modal card */}
      {  showModal &&
        <DisplayModal title={name} closeFn={() => setShowModal(false)}>
          <ProductDetailsCard 
            key={`modal${dispensaryId}${Id}`} 
            Id={Id} 
            name={name}
            category={category} 
            imageInfo={imageInfo}
            brand={brand} 
            description={description} 
            cost_usa_cents={cost_usa_cents}
            showOrderQuantity={showOrderQuantity}  /* order history */
            thc_lab_value={thc_lab_value}
            thc_lab_units={thc_lab_units}
            cbd_lab_value={cbd_lab_value}
            cbd_lab_units={cbd_lab_units}
            cannabisType={cannabis_type}
            grams={grams}
            leaf_logix_pricing_tier={leaf_logix_pricing_tier} 
            handleClick={(quantity) => addToCartClick(quantity)} />
        </DisplayModal> 
      }
    </>        
  )
}

DispensaryProduct.propTypes = {
  Id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  brand: PropTypes.string,
  description: PropTypes.string,
  category: PropTypes.object,
  image_url: PropTypes.string,
  cost_usa_cents: PropTypes.number.isRequired,
  is_featured: PropTypes.bool,
  grams: PropTypes.number.isRequired,
  leaf_logix_pricing_tier: PropTypes.object,
  thc_lab_value: PropTypes.string,
  thc_lab_units: PropTypes.string,
  cbd_lab_value: PropTypes.string,
  cbd_lab_unit: PropTypes.string,
  cannabis_type: PropTypes.string,
  dispensaryId: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  quantity: PropTypes.number,
  showOrderQuantity: PropTypes.bool,
  isFullWidth: PropTypes.bool,
};

export default DispensaryProduct;
